import { Box, Text, TextProps } from '@jfs/ui-new'
import { FC, useState } from 'react'
import { Clipboard } from 'react-native'
import { isStringBlank } from '../../../util/util'
import { styles } from './styles'

interface CopyViewProps {
  itemData: any
  entry: any
  statusStyle?: TextProps
  textStyles: TextProps
}
const CopyView: FC<CopyViewProps> = ({ itemData, entry, statusStyle, textStyles }: CopyViewProps) => {
  const [isHovering, setIsHovering] = useState(false)
  const [copied, setCopied] = useState(false)

  console.log(entry)
  const handleOnCopy = () => {
    Clipboard.setString(itemData?.url)
    setCopied && setCopied(true)
  }
  const viewStyle = copied ? styles.copiedStyle : styles.copyStyle
  const textStyle = copied ? styles.copiedTxtStyle : styles.copyTxtStyle

  const onHover = (isHover: boolean) => {
    if (isHover === false) {
      setCopied(false)
    }
    setIsHovering(isHover)
  }
  return (
    <Box flexDirection={'row'} onHover={onHover} disabled={false}>
      <Text {...textStyles} {...statusStyle}>
        {isStringBlank(itemData?.url) ? 'NA' : itemData?.url}
      </Text>
      {isHovering && (
        <Box {...viewStyle} onPress={handleOnCopy} testID="handle-Copy" marginLeft={4}>
          <Text {...textStyle}>{copied ? 'Copied' : 'Copy'}</Text>
        </Box>
      )}
    </Box>
  )
}

export { CopyView }
